/** After "Not now", don't ask again in this household for a few days. */
const SNOOZE_MS = 3 * 24 * 60 * 60 * 1000;

const snoozeKey = (householdId: string) => `tidy:welcome-back-snoozed:${householdId}`;

export function isWelcomeBackSnoozed(householdId: string, now = Date.now()): boolean {
  try {
    const raw = window.localStorage.getItem(snoozeKey(householdId));
    if (!raw) return false;
    const until = Number(raw);
    return Number.isFinite(until) && until > now;
  } catch {
    return false;
  }
}

export function snoozeWelcomeBack(householdId: string, now = Date.now()): void {
  try {
    window.localStorage.setItem(snoozeKey(householdId), String(now + SNOOZE_MS));
  } catch {
    // Storage unavailable (private mode) — the prompt will just show again next time.
  }
}
